import React from 'react'
import styled from 'styled-components'

import { white, hover } from 'styles/colors'

const Wrapper = styled.div`
  position: absolute;
  background-color: ${white};
  border-radius: 4px;
  width: 100%;
  top: calc(100% + 2px);
  overflow: hidden;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  z-index: 1;
`

const Suggestion = styled.div`
  background-color: ${props => (props.active ? hover : white)};
  margin: 1px 0;
  padding: 8px 20px;
  cursor: pointer;
`

const SuggestionList = ({
  suggestions,
  activeIndex,
  setHoverIndex,
  unsetHoverIndex,
  selectSuggestion,
}) => (
  <Wrapper>
    {suggestions.map((suggestion, index) => (
      <Suggestion
        key={suggestion}
        active={activeIndex === index}
        onMouseEnter={() => setHoverIndex(index)}
        onMouseLeave={unsetHoverIndex}
        onMouseDown={e => {
          e.preventDefault()
          selectSuggestion(suggestion)
        }}>
        {suggestion}
      </Suggestion>
    ))}
  </Wrapper>
)

export default SuggestionList



// WEBPACK FOOTER //
// ./src/components/withSuggestions/SuggestionList.js